module.exports = __webpack_public_path__ + "static/media/extension-medium.e5f3291e.png";


//////////////////
// WEBPACK FOOTER
// ./src/scenes/FAQ/assets/extension-medium.png
// module id = 921
// module chunks = 0